import React from "react";
import { Alert } from "react-bootstrap";

const ErrorFallback = ({ message }) => (
  <Alert variant="danger" className="my-5 text-center">
    {message || "Unable to join class. Please try again later."}
  </Alert>
);

export default ErrorFallback;
